<template>
  <aside class="item-options">
    <div style="padding: 0px 15px;" v-if="selectedCount != 0">
      <button class="arrow" @click="back">
        <arrow-left-icon size="1.5x" class="custom-class"></arrow-left-icon>
      </button>
      <div :id="name + '2'" style="cursor: pointer; height: 190px; margin-bottom: 27px;" v-on:click="this.open">
        <template v-if="(type == 'video' || type == 'audio' || type == 'stl') && size <= 50*1024*1024">
          <audio id="previewControl" v-if="type == 'audio'" :src="raw" style="max-height:100%; max-width:100%;" controls hidden></audio>
          <template v-else-if="type == 'video'">
            <video id="previewControl" v-if="raw" :src="raw" style="max-height:100%; max-width:100%;">
              <track
                kind="captions"
                v-for="(sub, index) in subtitles"
                :key="index"
                :src="sub"
                :label="'Subtitle ' + index" :default="index === 0">
              <font color="white">Sorry, your browser doesn't support embedded videos,
              but don't worry, you can <a id="previewControlAlt" :download="nodeName" :href="raw">download it</a>
              and watch it with your favorite video player!</font>
            </video>
            <img v-else class="material-icons" src="/img/icons/WEBCLIENT_MimeTypes/ibbVideo.svg">
          </template>
          <!-- <model-stl v-else-if="type == 'stl'" :src="raw" style="max-height:100%; max-width:100%;"></model-stl> -->
          <img v-else-if="type == 'stl'" class="material-icons" src="/img/icons/WEBCLIENT_MimeTypes/ibbFile.svg">
        </template>
        <a v-else id="previewControlImg" rel="nofollow">
          <img class="material-icons" :src="icon">
        </a>
      </div>
      
      <template v-if="isMultiSelected">
        <p class="name">{{ selectedCount }} {{ $t('files.selectedNodes') }}</p>
      </template>
      <template v-else>
        <p v-if="type === 'snapshot'" :title="snapshotName" class="name">{{ snapshotName }}</p>
        <p v-else class="name" :title="name">{{ name }}</p>
      </template>

      <div v-if="(!isRoot || (isRoot && isSecret)) && !isMultiSelected" style="display: flex; justify-content: center; align-items: center;">
        <p style="margin-bottom: 0;">
          <span v-if="!isDir || (type === 'snapshot' && status != Module.ErrorType.E_INCOMPLETE.value)" class="size">{{ humanSize }}</span>
          <span v-if="!isDir"> - </span>
          <span v-if="type !== 'snapshot'" class="time">{{ humanTime }}</span>
        </p>
      </div>
      <template v-if="currentNode && type === 'snapshot'">
        <p  :style="{'background-color': statusColor}" class="encrypted state">{{ statusText }}</p>
        <template v-if="status != Module.ErrorType.E_INCOMPLETE.value">
          <p>{{ $t('files.folders') }}: {{ currentNode.nfolders }}</p>
          <p>{{ $t('files.files') }}: {{ currentNode.nfiles }}</p>
          <p>{{ $t('backups.errors') }}: {{ currentNode.ntrerror }}</p>
          <p>{{ $t('backups.elapsedTime') }}: {{ elapsedTime }}</p>
        </template>
      </template>
      <template v-if="currentNode && type === 'backup'">
        <p :title="currentNode.lpath"
        style="overflow: hidden; text-overflow: ellipsis;"
        :aria-label="$t('backups.folder')">{{ currentNode.lpath }}</p>
        <p :title="backupCron"
        style="overflow: hidden; text-overflow: ellipsis;"
        :aria-label="$t('backups.cron')">{{ backupCron }}</p>
      </template>

      <div v-if="isBackup" class="botones">
        <button v-if="currentNode && type == 'snapshot' && status != Module.ErrorType.E_INCOMPLETE.value" :aria-label="$t('backups.snapshots.report')" :title="$t('backups.snapshots.report')" class="action" @click="downloadSnapshotReport">
          <download-cloud-icon size="1.2x" class="custom-class"></download-cloud-icon>
          <p>{{ $t('backups.snapshots.report') }}</p>
        </button>
        <br>
        <button v-if="!isRoot" :aria-label="buttonName" :title="buttonName" class="action" @click="download">
          <download-cloud-icon size="1.2x" class="custom-class"></download-cloud-icon>
          <p>{{ buttonName }}</p>
        </button>
        <template v-if="type === 'backup' && !isMultiSelected && this.permissions === 0">
          <br>
          <button @click="showModifyBackup" :aria-label="$t('prompts.modify')" :title="$t('prompts.modify')" class="action" id="rename-button">
            <Edit3Icon size="1.5x" class="custom-class"></Edit3Icon>
            <span>{{ $t('prompts.modify') }}</span>
          </button>
          <br>
          <button @click="runBackup" :aria-label="$t('buttons.run')" :title="$t('buttons.run')" class="action" id="modify-button">
            <PlayIcon size="1.5x" class="custom-class"></PlayIcon>
            <span>{{ $t('buttons.run') }}</span>
          </button>
        </template>
        <delete-button v-show="(type === 'snapshot' || type === 'backup' || type === 'device') && this.permissions === 0"></delete-button>
        <share-button v-show="showShareButton && this.permissions === 0"></share-button>
      </div>
      <div v-else class="botones-cloud">
        <button @click="versionHistory" v-if="!isDir && !isRoot && !isMultiSelected" :aria-label="$t('buttons.versions')" :title="$t('buttons.versions')" class="action">
          <file-text-icon size="1.5x" class="custom-class"></file-text-icon>
          <span>{{ $t('buttons.versions') }}</span>
        </button>
        <copy-button v-if="canBeCopied"></copy-button>
        <move-button v-if="canBeMoved"></move-button>
        <rename-button v-if="canBeRenamed"></rename-button>
        <download-button v-if="!isRoot"></download-button>
        <share-button v-if="canBeShared"></share-button>
        <delete-button v-if="canBeDeleted"></delete-button>
        <button v-if="isSharedWithMe && !isRoot && this.type === 'shared-drive'" @click="exitSharedDrive" :aria-label="$t('buttons.exit')" :title="$t('buttons.exit')" class="action" id="delete-button">
          <log-out-icon size="1.5x" class="custom-class"></log-out-icon>
          <span>{{ $t('buttons.exit') }}</span>
        </button>
        <button v-if="isMyDrives && this.type === 'shared-drive'" @click="archiveSharedDrive" :aria-label="$t('buttons.store')" :title="$t('buttons.store')" class="action" id="delete-button">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-archive"><polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line></svg>
          <span>{{ $t('buttons.store') }}</span>
        </button>
        <button @click="manageAccess" v-if="type === 'shared-drive' && !isArchived && !isSharedWithMe && selectedCount === 1 && this.permissions === 0 && this.permissionsSharedDrive === 0" :aria-label="$t('buttons.manageAccessMobile')" :title="$t('buttons.manageAccessMobile')" class="action">
          <users-icon size="1.5x" class="custom-class"></users-icon>
          <span>{{ $t('buttons.manageAccessMobile') }}</span>
        </button>
        <button v-if="(isMyDrives || isSharedWithMe) && this.type === 'shared-drive'" @click="startMeeting" :aria-label="$t('buttons.start-meeting')" :title="$t('buttons.start-meeting')" class="action">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-video"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
          <span>{{ $t('buttons.start-meeting') }}</span>
        </button>
        <button @click="desarchiveSharedDrive" v-if="type === 'shared-drive' && isArchived && selectedCount === 1 && this.permissions === 0 && this.permissionsSharedDrive === 0" :aria-label="$t('buttons.unarchive')" :title="$t('buttons.unarchive')" class="action">
          <rotate-ccw-icon></rotate-ccw-icon>
          <span>{{ $t('buttons.unarchive') }}</span>
        </button>
      </div>
      <div v-if="isShared && !isArchived" class="listado-usuarios">
        <div class="number-shared">
          <share-2-icon size="1.5x" class="custom-class"></share-2-icon>
          <p v-if="isMyDrives">{{ $t('sharedDrive.sharedWith') }}<b>{{ numberShared }}</b></p>
          <p v-else>{{ $t('sharedDrive.owner') }}</p>
        </div>
        <div v-if="isMyDrives" class="listing">
          <div v-for="(user, index) in usersShared" :key="index" class="user">
            <p class="name">{{ user.name.substr(0, 1) }}</p>
            <p class="email">{{ user.name }}</p>
          </div>
        </div>
        <div v-else-if="owner !== ''" style="margin-top: 5px;" class="user">
          <p class="name">{{ owner.substr(0, 1) }}</p>
          <p class="email">{{ owner }}</p>
        </div>
      </div>
    </div>
    
    <footer :class="{'has-tag': hasTag}" v-if="currentNode">
        <span>{{ hasTag ? $t('settings.encryptedAndTaggedWith') : $t('settings.encryptedWith')}}</span>
        <div class="container-tags">
          <div class="encrypted">
            <p>{{ encryptionAlgorithm }}</p>
          </div>

          <select v-if="hasTag" class="tag" v-model="tag" v-on:change="changeTag">
            <option :value=Module.TagType.TAG_UNSET.value>{{ $t('tag.unset') }}</option>
            <option :value=Module.TagType.TAG_PERSONAL.value>{{ $t('tag.personal') }}</option>
            <option :value=Module.TagType.TAG_PUBLIC.value>{{ $t('tag.public') }}</option>
            <option :value=Module.TagType.TAG_GENERAL.value>{{ $t('tag.general') }}</option>
            <option :value=Module.TagType.TAG_CONFIDENTIAL.value>{{ $t('tag.confidential') }}</option>
            <option :value=Module.TagType.TAG_HIGHLY_CONFIDENTIAL.value>{{ $t('tag.highConfidential') }}</option>
          </select>
        </div>
    </footer>
  </aside>
</template>

<style scoped>
footer {
  margin-top: auto;
  background-color: #8080802e;
  text-align: left;
  padding: 20px;
}
footer span {
  font-weight: 600;
  font-size: 14px;
}
footer .container-tags {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
footer.has-tag .container-tags {
  margin-top: 12px;
}
footer:not(.has-tag) {
  display: table;
}
footer:not(.has-tag) span {
  display: table-cell;
  vertical-align: middle;
}
footer:not(.has-tag) .container-tags {
  float: right;
}
footer.has-tag .container-tags select.tag {
  background-color: white;
  width: 165px;
  color: black;
  border: none;
  padding: 6px 10px;
  border-radius: 9px;
  font-weight: 500;
  font-size: 14px;
}
</style>

<script>
/* eslint-disable vue/return-in-computed-property */ 
/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable vue/no-side-effects-in-computed-properties */
import { DownloadCloudIcon, Share2Icon, FileTextIcon, ArrowLeftIcon, UsersIcon, LogOutIcon, RotateCcwIcon, Edit3Icon, PlayIcon } from 'vue-feather-icons';
import { mapGetters, mapState, mapMutations } from 'vuex';
import { files as api } from '@/api';
import * as pdf from '@/api/pdf';
import moment from 'moment';
import i18n from '@/i18n';
import filesize from 'filesize';
import cronstrue from 'cronstrue/i18n';
import CopyButton from '@/components/buttons/Copy.vue';
import MoveButton from '@/components/buttons/Move.vue';
import RenameButton from '@/components/buttons/Rename.vue';
import DownloadButton from '@/components/buttons/Download.vue';
import ShareButton from '@/components/buttons/Share.vue';
import DeleteButton from '@/components/buttons/Delete.vue';
// import { ModelStl } from 'vue-3d-model';
import { ROUTES } from '@/router';

export default {
  name: 'item-options',
  data: function () {
    return {
      name: '',
      modified: '',
      isDir: '',
      type: '',
      handle: '',
      size: '',
      buttonName: '',
      uri: '',
      fileId: '',
      subtitles: [],
      isRoot: false,
      isShared: false, 
      numberShared: 0,
      usersShared: [],
      owner: '',
      encryptionAlgorithm: '',
      isSafari: false,
      isSecret: false,
      isMultiSelected: false,
      tag: '',
      Module,
      virtualParentHandle: '',
    };
  },
  components: {
    DownloadCloudIcon,
    CopyButton,
    MoveButton,
    RenameButton,
    DownloadButton,
    ShareButton,
    DeleteButton,
    // ModelStl,
    Share2Icon,
    FileTextIcon,
    ArrowLeftIcon,
    UsersIcon,
    LogOutIcon,
    RotateCcwIcon,
    Edit3Icon,
    PlayIcon
},
  watch: {
    selected () {
      if (this.selectedCount === 1) {
        this.owner = '';
        let holder = document.getElementById('previewControlImg');
        if (holder) {
          holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbImage.svg" />';
        }
        this.isMultiSelected = false;
        if (!this.isSharedDrive || (this.isSharedDrive && window.location.hash !== '')) {
          this.isRoot = false;
          this.name = this.currentNode.name;
          this.handle = this.currentNode.handle;
          this.size = this.currentNode.size;
          this.encryptionAlgorithm = this.currentNode.crypto;
          if (this.req.subtitles) {
            this.subtitles = this.req.subtitles.map(sub => `${baseURL}/api/raw${sub}?auth=${this.jwt}&inline=true`);
          }
          if (this.currentNode.nodeType === Module.NodeType.SHARED_DRIVE_ROOT.value) {
            this.modified = moment(this.currentNode.mtime * 1000).format();
            this.type = 'shared-drive';
            this.isDir = true;
            this.isShared = true;
            this.virtualParentHandle = this.currentNode.virtualParentHandle;
            this.obtenerListadoCompartidos(this.handle);
          } else {
            this.modified = this.currentNode.modified;
            this.isDir = this.currentNode.isDir;
            this.type = this.currentNode.type;
            this.tag = this.currentNode.tag;
            this.isShared = false;
          }
        } else {
          this.isRoot = false;
          this.name = this.req.items[this.selected[0]].name;
          this.modified = moment(this.req.items[this.selected[0]].mtime * 1000).format();
          this.isDir = true;
          this.type = 'shared-drive';
          this.handle = this.req.items[this.selected[0]].handle;
          this.size = this.req.items[this.selected[0]].size;
          this.virtualParentHandle = this.req.items[this.selected[0]].virtualParentHandle;
          this.encryptionAlgorithm = this.req.items[this.selected[0]].crypto;
          this.isShared = true;
          this.obtenerListadoCompartidos(this.handle);
        }
        this.isSecret = false;
        this.fetchData();
      } else {
        this.isMultiSelected = true;
      } 
    },
    encryptionAlgorithm () {
      if (this.encryptionAlgorithm === 0) {
        this.encryptionAlgorithm = this.$t('settings.AES256');
      } else if (this.encryptionAlgorithm === 2) {
        this.encryptionAlgorithm = this.$t('settings.AES128');
      }
    }
  },
  async mounted() {
    this.setIsPrompt(true);
  },
  created () {
    if (window.navigator.vendor == 'Apple Computer, Inc.') {
      this.isSafari = true;
    }
    let thisComponent = this;
    let JavaEventListenerClass = Module.ActionListener.extend('ActionListener', {
      onActionFinish: function(action)
      {
        if (action.type === Module.ActionType.MANAGE_SHARED_DRIVES.value && window.location.hash !== '' && action.node === undefined && action.accountHandle !== '') {
          thisComponent.obtenerListadoCompartidos(thisComponent.$route.hash.replace('#', ''));
        } else {
          return;
        }
      }
    });

    this.interfaceObject = new JavaEventListenerClass();
    ibb.addActionListener(this.interfaceObject);
  },
  beforeDestroy () {
    ibb.removeActionListener(this.interfaceObject);
  },
  computed: {
    ...mapState(['req', 'selected', 'user', 'permissions', 'permissionsSharedDrive', 'isMaxStorage', 'show', 'userInfo']),
    ...mapGetters(['isListing', 'selectedCount', 'isBackup', 'isFiles', 'isRegister', 'isBin', 'isSharedDrive', 'isLogged', 'isCloud']),
    canBeCopied() {
      if (this.isRoot) return false;
      if (this.isShared) return false;
      if (this.isSharedFoldersRoute) return false;
      if (this.permissions === Module.AccessLevel.RO_ACCESS.value) return false;
      if (this.permissionsSharedDrive === Module.AccessLevel.RO_ACCESS.value) return false;
      if (this.isMaxStorage) return false;
      return true;
    },
    canBeMoved() {
      if (this.isRoot) return false;
      if (this.isArchived) return false;
      if (this.isSharedWithMe) return false;
      if (this.isSharedFoldersRoute) return false;
      if (this.permissions === Module.AccessLevel.RO_ACCESS.value) return false;
      if (this.permissionsSharedDrive === Module.AccessLevel.RO_ACCESS.value) return false;
      return true;
    },
    canBeRenamed() {
      if (this.isRoot) return false;
      if (this.isMultiSelected) return false;
      if (this.isSharedFoldersRoute) return false;
      if (this.permissions === Module.AccessLevel.RO_ACCESS.value) return false;
      if (this.permissionsSharedDrive === Module.AccessLevel.RO_ACCESS.value) return false;
      if (!(this.isMyDrives || this.isArchived || (this.isDrive && this.type !== 'shared-drive') || (this.isSharedWithMe && this.type !== 'shared-drive') || this.isCloud)) {
        return false;
      }
      return true;
    },
    canBeDeleted() {
      if (this.isRoot) return false;
      if (this.permissions === Module.AccessLevel.RO_ACCESS.value) return false;
      if (!(this.isArchived || ((this.isSharedDrive || this.isMyDrives) && this.type !== 'shared-drive') || !this.isSharedDrive)) {
        return false;
      }
      if (!(this.permissionsSharedDrive === Module.AccessLevel.RW_ACCESS.value && (!this.isDrive || this.type !== 'shared-drive'))
          && !(this.permissionsSharedDrive === Module.AccessLevel.RO_ACCESS.value && (this.type === 'shared-drive') && !this.isDrive)) {
        return false;
      }
      if (!(this.currentNode && !this.currentNode.synced)) {
        return false;
      }
      return true;
    },
    canBeShared() {
      if (this.isRoot) return false;
      if (this.isMultiSelected) return false;
      if (this.isShared) return false;
      if (this.isDrive) return false;
      if (this.permissions === Module.AccessLevel.RO_ACCESS.value) return false;
      if (this.permissionsSharedDrive === Module.AccessLevel.RO_ACCESS.value) return false;
      return true;
    },
    raw: function() {
      // eslint-disable-next-line vue/no-async-in-computed-properties
      setTimeout(() => {
        let previewControlAlt = document.getElementById('previewControlAlt');
        if (previewControlAlt) {
          previewControlAlt.href = this.uri;
          previewControlAlt.download = this.name;
          previewControlAlt.hidden = false;
        }
                                          
        let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        if (iOS) {
          let reader = new FileReader();
          let out = Module.getFileBlob(this.linkid);
          reader.onload = function() {
            let downloadLinkTag = document.getElementById('downloadLinkTag');
            if (downloadLinkTag) {
              downloadLinkTag.href = reader.result;
              downloadLinkTag.download = this.name;
            }

            if (!this.name.endsWith('.txt') && !this.name.endsWith('.pdf')) {
              const previewControlAlt = document.getElementById('previewControlAlt');
              if (previewControlAlt) {
                previewControlAlt.href = reader.result;
                previewControlAlt.download = this.name;
                previewControlAlt.hidden = false;
              }
            }
            downloadLinkTag.click();
          };
          reader.readAsDataURL(out);
        }
      }, 0);

      return this.uri;
    },
    currentNode() {
      if (!this.req.items || this.selectedCount != 1) {
        return null;
      }
      return this.req.items[this.selected[0]];
    },
    humanSize() {
      if (this.currentNode.size !== undefined) {
        return filesize(this.currentNode.size);
      }
      return;
    },
    humanTime() {
      return this.currentNode && moment(this.currentNode.modified).format('DD/MM/YYYY HH:mm:ss');
    },
    snapshotName() {
      const matches = this.currentNode.name.match(/^.*-\s(\d{4})_(\d{2})_(\d{2})\s(\d{2})_(\d{2})_(\d{2})$/);
      const date = new Date(+matches[1],+matches[2]-1,+matches[3], +matches[4],+matches[5],+matches[6]);
      return date.toLocaleString();
    },
    backupCron() {
      return cronstrue.toString(this.currentNode.cron);
    },
    status() {
      return this.currentNode ? this.currentNode.status : null;
    },
    statusText() {
      if (this.type === 'snapshot' && this.status != null) {
        switch (this.status) {
          case Module.ErrorType.E_SUCCESS.value: 
            return i18n.t('info.correct');
          case Module.ErrorType.E_INCOMPLETE.value: 
            return i18n.t('info.incomplete');
          case Module.ErrorType.E_CANCELLED.value: 
            return i18n.t('transfers.cancelled');
          default: 
            return i18n.t('info.incorrect');
        }
      }
    },
    statusColor() {
      if (this.type === 'snapshot' && this.status != null) {
        switch (this.status) {
          case Module.ErrorType.E_SUCCESS.value: 
            return '#4daa57';
          case Module.ErrorType.E_INCOMPLETE.value: 
            return 'var(--blue)';
          case Module.ErrorType.E_CANCELLED.value: 
            return '#a31621';
          default: 
            return '#a31621';
        }
      }
    },
    elapsedTime() {
      const elapsedTime = this.currentNode.ftime - this.currentNode.stime;
      return moment.duration(elapsedTime >= 0 ? elapsedTime : 0, 'seconds').humanize();
    },
    hasTag() {
      return !this.isShared && !this.isBackup && (this.currentNode && this.currentNode.nodeType !== Module.NodeType.SHARE.value);
    },
    nodeName () {
      let path = `${this.req.path}`;
      path = decodeURIComponent(path);
      let fileName = path.replace(/^.*[\\/]/, '');
      return fileName;
    },
    icon () {
      if (this.selectedCount > 1) {
        this.buttonName = i18n.t('buttons.restoreFolder');
        // eslint-disable-next-line vue/no-async-in-computed-properties
        setTimeout(function() { 
          let holder = document.getElementById('previewControlImg');
          if (holder) {
            holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbVersions.svg" />';
          }
        }, 0);
        return;
      } else {
        if (this.isDir)
        {
          if (this.type === 'device')
          {
            this.buttonName = i18n.t('buttons.restoreDevice');
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() {
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbDevice.svg" />';
              }
            }, 0);
            return;
          }
          else if (this.type === 'backup')
          {
            this.buttonName = i18n.t('buttons.restoreFolder');
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbBackup.svg" />';
              }
            }, 0);
            return;
          }
          else if (this.type === 'snapshot')
          {
            this.buttonName = i18n.t('buttons.restoreCopy');
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbCalendar.svg" />';
              }
            }, 0);
            return; 
          }
          else if (this.type === 'inbox')
          {
            return '/img/icons/mimetype_inbox.png';
          }
          else if (this.type === 'record')
          {
            return '/img/icons/mimetype_record.png';
          }
          else if (this.type === 'shared-drive') {
            this.buttonName = i18n.t('buttons.restoreFolder');
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbSharedDrive.svg" />';
              }
            }, 0);
            return;
          }
          else if (this.type === 'shared') {
            return '/img/icons/WEBCLIENT_MimeTypes/ibbSharedFolder.svg';
          }
          else
          {
            this.buttonName = i18n.t('buttons.restoreFolder');
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(() => { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                if (this.currentNode && this.currentNode.synced) {
                  holder.innerHTML = '<img src="/img/icons/WEBCLIENT_MimeTypes/ibbSyncFolder.svg" />';
                } else {
                  holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbFolder.svg" />';
                }
              }
            }, 0);
            return;
          }
        } else {
          this.buttonName = i18n.t('buttons.download');
          if (this.type === 'image') 
          {  
            let thumbnailName = '///thumbnails/' + this.handle;
            if (!window.gRequestedThumbnails.has(thumbnailName))
            {
              let uri = Module.getObjectURL(thumbnailName);
              if (uri)
              {
                // eslint-disable-next-line vue/no-async-in-computed-properties
                setTimeout(function() { 
                  let holder = document.getElementById('previewControlImg');
                  if (holder) {
                    holder.style.width = '90%';
                    holder.style.marginLeft = 'auto';
                    holder.style.marginRight = 'auto';
                    holder.innerHTML='<img src="' + uri + '" />';
                  }
                }, 0);
              }
              else
              {
                window.gRequestedThumbnails.add(thumbnailName);
                let promise;
                if (this.$route.name !== ROUTES.DRIVE) {
                  promise = ibb.downloadMetadata(this.handle, Module.MetadataType.META_THUMBNAIL.value, thumbnailName);
                } else {
                  promise = ibbLink.downloadMetadata(this.handle, Module.MetadataType.META_THUMBNAIL.value, thumbnailName);
                }
                // eslint-disable-next-line vue/no-async-in-computed-properties
                promise.then(function(action) {
                  if (!action.error.type)
                  {
                    window.gRequestedThumbnails.delete(thumbnailName);
                    let uri = Module.getObjectURL(thumbnailName);
                    let holder = document.getElementById('previewControlImg');
                    if (holder) {
                      holder.style.width = '90%';
                      holder.style.marginLeft = 'auto';
                      holder.style.marginRight = 'auto';
                      holder.innerHTML='<img src="' + uri + '" />';
                    }
                  }
                });
              }
            }
            return;
          }
          if (this.type === 'audio') {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbAudio.svg" />';
              }
            }, 0);
            return;
          }
          if (this.type === 'video') {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbVideo.svg" />';
              }
            }, 0);
            return;
          } 
          if (this.type === 'txt') {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbTxt.svg" />';
              }
            }, 0);
            return ;
          } 
          if (this.type === 'pdf') {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbPDF.svg" />';
              }
            }, 0);
            return;
          }
          if (this.type === 'zip') {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbZIP.svg" />';
              }
            }, 0);
            return ;
          }
          if (this.type === 'xls') {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbXLS.svg" />';
              }
            }, 0);
            return ;
          }
          if (this.type === 'doc') {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbDoc.svg" />';
              }
            }, 0);
            return ;
          }
          if (this.type === 'ppt') {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbPPT.svg" />';
              }
            }, 0);
            return ;
          }
          if (this.type === 'code') {
            // eslint-disable-next-line vue/no-async-in-computed-properties
            setTimeout(function() { 
              let holder = document.getElementById('previewControlImg');
              if (holder) {
                holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbCode.svg" />';
              }
            }, 0);
            return ;
          }
          // eslint-disable-next-line vue/no-async-in-computed-properties
          setTimeout(function() { 
            let holder = document.getElementById('previewControlImg');
            if (holder) {
              holder.innerHTML='<img src="/img/icons/WEBCLIENT_MimeTypes/ibbFile.svg" />';
            }
          }, 0);
          return;
        }
      }
    },
    showCopyButton () {
      if ((this.isFiles && !this.isBackup && !this.isRegister && !this.isBin) && (this.isListing
        ? (this.selectedCount > 0 && this.user.perm.create)
        : this.user.perm.create))
        {
            if (!this.isRegister) {
              return true;
            }

            for (let i = 0; i < this.$store.state.selected.length; i++) {
              let type = this.req.items[this.$store.state.selected[i]].nodeType;
              if (type != Module.NodeType.FILE.value && type != Module.NodeType.FOLDER.value) {
                return true;
              }
            }
            return true;
        }
        return false;
    },
    showMoveButton () {
      return this.isFiles && !this.isBackup && !this.isRegister && (this.isListing
        ? (this.selectedCount > 0 && this.user.perm.rename)
        : this.user.perm.rename);
    },
    showDownloadButton () {
      return this.isFiles && this.selectedCount === 1 && this.user.perm.download;
    },
    showShareButton () {
      return this.isFiles && !this.isBin && (this.isListing
        ? (this.selectedCount === 1 && this.user.perm.share && 
          (!this.isDir 
          || this.type == 'inbox'
          || this.type == 'folder'))
        : this.user.perm.share);
    },
    isMyDrives() {
      return this.$route.name === ROUTES.MY_SHARED_DRIVES;
    },
    isSharedWithMe() {
      return this.$route.name === ROUTES.SHARED_WITH_ME;
    },
    isDrive() {
      return this.$route.name === ROUTES.DRIVE;
    },
    isArchived() {
      return this.$route.name === ROUTES.ARCHIVED;
    },
    isSharedFoldersRoute() {
      return this.$route.name === ROUTES.SHARED_FOLDERS;
    }
  },
  methods: {
    ...mapMutations(['setIsPrompt']),
    showModifyBackup() {
      this.$store.commit('showHover', 'modify-backup');
    },
    async runBackup() {
      if (confirm('La ejecución remota de la copia no está garantizada puesto que depende de tener corriendo la aplicación de escritorio en el equipo de destino. ¿Desea continuar?')) {
        await ibb.changeBackupStatus(this.currentNode.handle, Module.BackupStatus.PENDING.value);
        this.$store.commit('resetSelected');
      }
    },
    async startMeeting() {
      const action = await ibb.getMeetingAccess(this.handle);
      const link = `https://meet.iberbox.com/${action.text}?jwt=${action.session}`;
      window.open(link);
    },
    exitSharedDrive() {
      this.$store.commit('showHover', 'delete');
    },
    archiveSharedDrive () {
      this.$store.commit('showHover', 'archive-shared-drive');
    },
    desarchiveSharedDrive() {
      this.unarchiveNestedDrive(this.handle, this.virtualParentHandle);
      this.back();
      this.$store.commit('resetSelected');
    },
    async unarchiveNestedDrive(handle, virtualParentHandle) {
      let action = await ibb.unarchiveSharedDrive(handle);

      let nestedShares = await ibb.getSharedDrives();
      nestedShares = nestedShares.nodeList.filter(item => item.virtualParentHandle === handle);

      if (virtualParentHandle !== '') {
        let nodeParent = await ibb.getNodeById(virtualParentHandle);
        if (nodeParent.node.archived) {
          await ibb.unnestSharedDrive(handle);
        }
      }

      for (let sharedDrive of nestedShares) {
        this.unarchiveNestedDrive(sharedDrive.handle, sharedDrive.virtualParentHandle);
      }
      
      if (action.error.type) {
        this.$showError(this.$t('errors.errorUnarchiveDrive'));
        return;
      }
    },
    changeTag: async function () {
      await ibb.setNodeTag(this.handle, this.tag);
    },
    async comprobarMiniatura() {
      let thumbnailName = '///thumbnails/' + this.handle;
      let uri = Module.getObjectURL(thumbnailName);
      if (!uri)
      {
        if (this.size > 52428800) return;
        const actionMetadata = await ibb.downloadMetadata(this.handle, Module.MetadataType.META_THUMBNAIL.value, thumbnailName);
        if (actionMetadata.error.type) {
          await ibb.downloadWithCustomData(this.handle, this.name, 'thumbnail');
          let url = Module.getObjectURL(this.name);
          let file = Module.getFile(this.name);

          await new Promise(resolve => {
            Module.createMetadata(url, Module.MetadataType.META_THUMBNAIL.value, (data) => {
              Module.createFile(thumbnailName, data);
              ibb.uploadMetadata(thumbnailName, this.handle, Module.MetadataType.META_THUMBNAIL.value)
              .finally(() => resolve());
            }, file['orientation']);
          });
        }
        uri = Module.getObjectURL(thumbnailName);
      }
      let holder = document.getElementById('previewControlImg');
      if (holder) {
        holder.style.width = '90%';
        holder.style.marginLeft = 'auto';
        holder.style.marginRight = 'auto';
        holder.innerHTML='<img src="' + uri + '" />';
      }
    },
    download: function () {
      api.downloadId(this.handle);
      this.$showSuccess(this.$t('transfers.downloadadded'));
      return;
    },
    deleteItem: function () {
      this.$store.commit('showHover', 'delete');
    },
    share: function () {
      this.$store.commit('showHover', 'share');
    },
    versionHistory() {
      this.$store.commit('showHover', 'version-history');
    },
    back() {
      this.setIsPrompt(false);
      this.$store.commit('closeHovers');
    },
    open: function () { 
      if ((!this.isDir && this.size > 50*1024*1024) || (this.type === 'pdf' && this.isSafari))
      {
        api.downloadId(this.handle);
        this.$showSuccess(this.$t('transfers.downloadadded'));
        return;
      }
      if (!this.isRoot) {
        this.$router.push({path: this.$route.path + '#' + this.handle});
      }
    },
    fetchData: async function () {
      if (this.size <= 50*1024*1024 && this.type === 'video') {
        this.fileId = this.handle + '/' + this.name;
        if (this.$route.name !== ROUTES.DRIVE) {
          await ibb.downloadWithCustomData(this.handle, this.fileId, 'preview');
        } else {
          await ibbLink.downloadWithCustomData(this.handle, this.fileId, 'preview');
        }
        this.uri = Module.getObjectURL(this.fileId);
      } else if (this.type === 'image') {  
        await this.comprobarMiniatura();
      }
    },
    async obtenerListadoCompartidos(handle) {
      if (this.$route.name === ROUTES.MY_SHARED_DRIVES) {
        let action = await ibb.getSharedDriveInfo(handle);
        this.numberShared = action.accountPermissions.filter(item => item.handle !== '').length;
        this.usersShared = action.accountPermissions.filter(item => item.handle !== '');
      } else {
        let action;
        if (this.$route.name !== ROUTES.DRIVE) {
          action = await ibb.getNodeById(handle);
          action = await ibb.getPublicAccountInfo(action.node.sourceHandle);
        } else {
          action = await ibbLink.getNodeById(handle);
          action = await ibbLink.getPublicAccountInfo(action.node.sourceHandle);
        }
        this.owner = action.name;
      }
    },
    manageAccess() {
      this.$store.commit('showHover', 'manage-access');
    },
    downloadSnapshotReport() {
      pdf.generateSnapshotReportPdf(this.userInfo, this.currentNode);
    }
  }
};
</script>